import React from "react";
import styles from "../../Form.module.scss";

// Split into two components so the hook call in DynamicSpecial is always unconditional.
function SpecialControl({ special, substepKeyToId, onChange, ...rest }) {
  const { Component, options, useOptions, withStateAutoFill, ...extras } = special;

  const onOptionSelect = withStateAutoFill
    ? (opt) => {
        const stateId = substepKeyToId?.shipping_state;
        if (opt?.stateValue && stateId != null) {
          onChange(stateId, { string_value: opt.stateValue });
        }
      }
    : undefined;

  if (useOptions) {
    return (
      <DynamicSpecial
        Component={Component}
        useOptions={useOptions}
        onOptionSelect={onOptionSelect}
        onChange={onChange}
        {...extras}
        {...rest}
      />
    );
  }
  return <Component options={options} onOptionSelect={onOptionSelect} onChange={onChange} {...extras} {...rest} />;
}

function DynamicSpecial({ Component, useOptions, ...rest }) {
  const { options, loading, error } = useOptions();

  if (loading) {
    return <div className={styles.muted}>Loading options…</div>;
  }
  if (error) {
    return <div className={styles.fieldError}>{error}</div>;
  }
  return <Component options={options || []} {...rest} />;
}

export default SpecialControl;
